export default {
  blue: "#008AFF",
  gray: "#282A2D",
  dark_gray: "#1a1a1a",
  black: "#000000",
  white: "#ffffff",
  off_white: '#FCFCFC',
  red: "#eb1c23",
  green: '#16C98D',
}
